<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item>商品中心</el-breadcrumb-item>
			<el-breadcrumb-item>自有商品</el-breadcrumb-item>
		</el-breadcrumb>
		<el-form :inline="true" :model="item" class="search">
			<el-form-item label="商品名称">
				<el-input v-model="item.name" placeholder="请输入商品名称" size="small"></el-input>
			</el-form-item>
			<el-form-item label="商品分类">
				<el-cascader v-model="item.store_category_id" placeholder="请选择商品分类"
					:options="cate" :props="filterProps" clearable></el-cascader>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="submit" size="medium">查询</el-button>
			</el-form-item>
		</el-form>
		<div class="btns">
			<el-button type="primary" size="small" @click="add" v-auth="['supplier/product/add']">添加商品</el-button>
		</div>
		<el-table :data="list" border>
			<el-table-column width="60" align="center">
				<template slot-scope="scope">
					{{scope.$index + (page-1) * pageSize + 1}}
				</template>
			</el-table-column>
			<el-table-column prop="name" label="商品">
				<template slot-scope="scope">
					<div class="thumb">
						<img :src="scope.row.product_pic_main" />
						{{scope.row.name}}
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="category" label="商品分类">
				<template slot-scope="scope" v-if="scope.row.category">
					{{scope.row.category.name}}
				</template>
			</el-table-column>
			<el-table-column label="上架" width="60">
				<template slot-scope="scope">
					<el-tag effect="dark" type="success" size="small" class="el-icon-check" v-if="scope.row.is_marketable"></el-tag>
					<el-tag effect="dark" type="danger" size="small" class="el-icon-close" v-else></el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="created_date" width="160" label="添加时间"></el-table-column>
			<el-table-column prop="last_modified_date" width="160" label="更新时间"></el-table-column>

			<el-table-column label="操作" width="320">
				<template slot-scope="scope">
					<el-popconfirm v-if="scope.row.is_marketable" title="您确定要下架吗？" @confirm="putOff(scope.row.goods_id)">
						<el-button style="margin-left: 10px;" size="mini" type="default" slot="reference">下架</el-button>
					</el-popconfirm>
					<el-popconfirm v-else title="您确定要上架吗？" @confirm="putOn(scope.row.goods_id)">
						<el-button style="margin-left: 10px;" size="mini" type="warning" slot="reference">上架</el-button>
					</el-popconfirm>
					<el-button style="margin-left: 10px;" v-if="!scope.row.in_store" size="mini" type="primary"
						@click="changePrice(scope.row.goods_id)">修改价格</el-button>
					<el-button style="margin-left: 10px; " size="mini" type="primary" @click="edit(scope.row.goods_id)">编辑</el-button>
					<el-popconfirm style="margin-left: 10px;" title="您确定要删除这件商品吗？" @confirm="del(scope.row.goods_id)">
						<el-button size="mini" type="danger" slot="reference">删除</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page" :page-sizes="[20, 100, 200, 300, 400]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
	</div>
</template>
<script>
export default {
	data() {
		return {
			list: [],
			isLoad: false,
			pageSize: 20,
			page: 1,
			total: 0,
			item:{
				store_category_id:[]
			},
			cate:[],
			filterProps: {
				value: 'id',
				label: 'name',
				emitPath: false,
				checkStrictly: true
			},
		}
	},
	created() {
		this.loadData();
	},
	methods: {
		loadList() {
			this.isLoad = !this.isLoad
			this.axios.get('store/Goods/index',{params:{
				page: this.page,
				pagesize: this.pageSize,
				name: this.item.name,
				store_category_id: this.item.store_category_id
			}}).then(res => {
				this.isLoad = !this.isLoad
				this.list = res.data.list.data
				this.total = res.data.list.total
			}).catch(() => {
				this.isLoad = !this.isLoad
			})
		},
		sizeReload(val) {
			this.pageSize = val
			this.loadList()
		},
		pageReload(val) {
			this.page = val
			this.loadList()
		},
		edit(id) {
			this.$router.push({
				path: '/Goods/edit.html',
				query: {
					id: id,
					op: 1
				}
			});
		},
		putOn(id) {
			this.isLoad = !this.isLoad
			this.axios.post('/store/product/putOn', {
				id: id,
			}).then(res => {
				this.isLoad = !this.isLoad
				this.$message.success({
					message: '上架成功'
				});
				this.loadList()
			}).catch(() => {
				this.isLoad = !this.isLoad
			})
		},
		putOff(id) {
			this.isLoad = !this.isLoad
			this.axios.post('/store/product/putOff', {
				id: id,
			}).then(res => {
				this.isLoad = !this.isLoad
				this.$message.success({
					message: '下架成功'
				});
				this.loadList()
			}).catch(() => {
				this.isLoad = !this.isLoad
			})
		},
		changePrice(id,name) {
			this.$router.push({
				path: '/Goods/price.html',
				query: {
					id: id
				}
			});
		},
		add() {
			this.$router.push({
				path: '/Goods/add.html',
				query: {
					op: 1
				}
			});
		},
		del(id) {
			this.isLoad = !this.isLoad
			this.axios.delete('/store/product/deleteOne', {data: {
				id
			}}).then(() => {
				this.isLoad = !this.isLoad
				this.$message.success({
					message: '删除成功',
				});
				this.loadList()
			}).catch(() => {
				this.isLoad = !this.isLoad
			})
		},
		loadData() {
			this.axios.get('/store/data/getCategoryTreeStore').then(res => {
				this.cate = res.data.list
				this.loadList()
			})
		},
		submit() {
			this.page = 1
			this.loadList()
		}
	}
}
</script>
<style scoped>
</style>
